import type { SoulConfig, UpsertSoulConfigRequest, UserProfile, UpsertUserProfileRequest, SoulPreview } from '../types/soul.js';

const SOUL_URL = '/api/soul';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getSoulConfig(): Promise<SoulConfig> {
  return fetchJson<SoulConfig>(`${SOUL_URL}/config`);
}

export async function updateSoulConfig(data: UpsertSoulConfigRequest): Promise<SoulConfig> {
  return fetchJson<SoulConfig>(`${SOUL_URL}/config`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function updateSoulMarkdown(markdown: string): Promise<SoulConfig> {
  return fetchJson<SoulConfig>(`${SOUL_URL}/markdown`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ markdown }),
  });
}

export async function getUserProfile(): Promise<UserProfile> {
  return fetchJson<UserProfile>(`${SOUL_URL}/profile`);
}

export async function updateUserProfile(data: UpsertUserProfileRequest): Promise<UserProfile> {
  return fetchJson<UserProfile>(`${SOUL_URL}/profile`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function getSoulPreview(): Promise<SoulPreview> {
  return fetchJson<SoulPreview>(`${SOUL_URL}/preview`);
}

export type { SoulConfig, UpsertSoulConfigRequest, SoulSection, SoulStructuredData, UserProfile, UpsertUserProfileRequest, SoulPreview } from '../types/soul.js';
